<template>
    <header class="topbar">
        <nav class="navbar top-navbar navbar-expand-md navbar-light">
            <div class="navbar-header" style="background-color: #262626;">
                <a class="navbar-brand" href="/">
                    <img :src="getIcon" />
                </a>
            </div>
            <div class="navbar-collapse">
                <ul class="navbar-nav mt-md-0 ">
                    <li class="nav-item"> <a class="nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark" href="javascript:void(0)"><i class="fas fa-bars"></i></a> </li>
                    <li class="nav-item"> <a class="nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark" href="javascript:void(0)"><i class="icon-arrow-left-circle fas"></i></a> </li>

                    <li class="nav-item d-none d-sm-inline" v-if="getConfig('maintenance_mode')"><span class="mt-4 badge badge-danger m-b-10">{{trans('configuration.under_maintenance')}}</span></li>
                    <li class="nav-item d-none d-sm-inline" v-if="!getConfig('mode')"><span class="mt-4 badge badge-danger m-b-10">{{trans('configuration.test_mode')}}</span></li>
                    <li class="nav-item hidden-sm-down d-none d-sm-inline">
                        <a class="nav-link" href="#">{{trans('general.any_search_title')}}</a>
                    </li>

                </ul>
                <ul class="navbar-nav flex-filler"></ul>
                <ul class="navbar-nav my-lg-0">
                    <li class="nav-item hidden-sm-down">
                        <global-search></global-search>
                    </li>
                    <li class="nav-item dropdown" v-if="getAcademicSessions.length && !hasPermission('change-academic-session')">
                        <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="#">{{getDefaultAcademicSession ? getDefaultAcademicSession.name : ''}}</a>
                    </li>
                    
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-user"></i>
                        </a>
                        <div :class="['dropdown-menu', getConfig('user_direction') != 'rtl' ? 'dropdown-menu-right' : '']">
                            <ul class="dropdown-user">
                                <li>
                                    <div class="dw-user-box">
                                        <div class="u-text">
                                            <h6></h6>
                                        </div>
                                    </div>
                                </li>
                                
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
    </header>
</template>

<script>
    import globalSearch from './global-search'
    export default {
        components: {globalSearch},
        mounted() {
        },
        methods : {
            logout(){
                helper.logout().then(() => {
                    this.$router.push('/login')
                })
            },
            getAuthUser(name){
                return helper.getAuthUser(name);
            },
            getConfig(name){
                return helper.getConfig(name);
            },
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            hasRole(role){
                return helper.hasRole(role);
            },
            setDefaultAcademicSession(academic_session){
                axios.post('/api/academic/session/'+academic_session.id+'/user/default')
                    .then(response => {
                        this.$store.dispatch('setDefaultAcademicSession',academic_session);
                        location.reload();
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        },
        computed: {
            getIcon(){
                return helper.getIcon();
            },
            getAcademicSessions(){
                return helper.getAcademicSessions();
            },
            getDefaultAcademicSession(){
                return helper.getDefaultAcademicSession();
            },
            getAuthUserRoles() {
                return helper.ucword(this.$store.getters.getAuthUserRoles);
            }
        }
    }
</script>
